import { useQuery } from '@apollo/react-hooks'

import { TierGroup } from 'generated/types'

import TierGroupForUserQuery from './gql/DeprecatedTierGroupForUser.query.gql'

type TierGroupForUserResponse = {
  tierGroupForUser: TierGroup
}

export const useTierGroupForUser = () => {
  return useQuery<TierGroupForUserResponse>(TierGroupForUserQuery, {
    fetchPolicy: 'network-only',
  })
}
